/* --- WISHLIST MANAGER --- */
if (typeof WishlistManager === "undefined") {
  class WishlistManager {
    constructor() {
      this.storageKey = "shopify_wishlist";
      this.items = [];
      this.loadWishlist();
      this.bindEvents();
      this.updateAllButtons();
      this.updateCount();
    }

bindEvents() {
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("[data-wishlist]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      this.toggle(btn);
    },
    true
  );

  document.addEventListener("shopify:section:load", () => {
    this.refresh();
  });

  document.addEventListener("product-recommendations:loaded", () => {
    this.refresh();
  });

  window.addEventListener("storage", (e) => {
    if (e.key === this.storageKey) {
      this.refresh();
    }
  });
}

    refresh() {
      this.loadWishlist();
      this.updateAllButtons();
      this.updateCount();
    }

    loadWishlist() {
      try {
        this.items = JSON.parse(localStorage.getItem(this.storageKey)) || [];
      } catch {
        this.items = [];
      }
    }

    saveWishlist() {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: this.items } }));
    }

    isInWishlist(productId) {
      return this.items.some((item) => String(item.id) === String(productId));
    }

    toggle(button) {
      const productId = button.dataset.productId;
      const productTitle = button.dataset.productTitle;
      const productHandle = button.dataset.productHandle;

      if (!productId || !productHandle) {
        console.warn("Wishlist: Missing product data");
        return;
      }

      if (this.isInWishlist(productId)) {
        this.remove(productId, button);
      } else {
        this.add(productId, productTitle, productHandle, button);
      }
    }

    add(id, title, handle, button) {
      this.items.push({ id, title, handle });
      this.saveWishlist();
      button.classList.add("is-active");
      this.updateCount();
    }

    remove(id, button) {
      this.items = this.items.filter((item) => String(item.id) !== String(id));
      this.saveWishlist();
      button.classList.remove("is-active");
      this.updateCount();
    }

    updateAllButtons() {
      document.querySelectorAll("[data-wishlist]").forEach((btn) => {
        if (this.isInWishlist(btn.dataset.productId)) {
          btn.classList.add("is-active");
        } else {
          btn.classList.remove("is-active");
        }
      });
    }

    updateCount() {
      const count = this.items.length;
      document.querySelectorAll(".wishlist-count-text").forEach((el) => {
        el.textContent = count > 99 ? "99+" : count;
      });
      document.querySelectorAll(".wishlist-count-bubble").forEach((el) => {
        el.style.display = count > 0 ? "flex" : "none";
      });
    }
  }

  window.WishlistManager = WishlistManager;
}

// Init when DOM is ready or immediately if already loaded
function initWishlistManager() {
  if (!window.wishlistInstance) {
    window.wishlistInstance = new WishlistManager();
  } else {
    window.wishlistInstance.refresh();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWishlistManager);
} else {
  initWishlistManager();
}
